import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Icon from '../Icon/Icon';
import { IconKeys } from '../Icon/IconKeys';
import S from './ImagePreviewStyles';

type Props = {
  src: string;
  alt: string;
  onClose: () => void;
};

function ImagePreview({ src, alt, onClose }: Props): JSX.Element {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent): void => {
      if (event.key !== 'Escape') {
        return;
      }

      event.stopImmediatePropagation();
      onClose();
    };

    document.addEventListener('keydown', closeOnEscape, true);

    return () => document.removeEventListener('keydown', closeOnEscape, true);
  }, [onClose]);

  return createPortal(
    <S.Wrapper role="dialog" aria-modal="true" aria-label={alt} onClick={onClose}>
      <S.CloseButton
        type="button"
        title="Close"
        aria-label="Close photo preview"
        onClick={onClose}
      >
        <Icon iconKey={IconKeys.CLOSE} />
      </S.CloseButton>
      {failedSrc === src ? (
        <S.Message onClick={(event) => event.stopPropagation()}>Picture not available</S.Message>
      ) : (
        <S.Image
          src={src}
          alt={alt}
          onClick={(event) => event.stopPropagation()}
          onError={() => setFailedSrc(src)}
        />
      )}
    </S.Wrapper>,
    document.body,
  );
}

export default ImagePreview;
